import React from "react";
import Header from "./components/General/Header";
import LoginComp from "./components/General/Login.component";

const Login = () => {
  return (
    <>
      <Header />
      <LoginComp />
    </>
  );
};

export default Login;
